/*
 * 3nds Nordic — infinite scroll på kategorisidor.
 * Progressiv förbättring ovanpå Dawns paginering:
 *  - riktiga sidlänkar finns kvar i markup (SEO + no-JS), döljs via CSS när JS är på
 *  - nästa sida hämtas vid skroll (IntersectionObserver) och korten appendas
 *  - behåller filter/sort-query (nästa-URL kommer från paginate.next.url)
 *  - "Visa fler"-knapp som fallback när IntersectionObserver saknas
 *  - återställs när filter/sortering ändras (Dawn ersätter #ProductGridContainer)
 */
(function () {
  var CONTAINER_ID = 'ProductGridContainer';
  var io = null;
  var mo = null;
  var loading = false;

  function $container() { return document.getElementById(CONTAINER_ID); }
  function $grid() { return document.getElementById('product-grid'); }
  function $control() {
    var c = $container();
    return c ? c.querySelector('.infinite-3nds') : null;
  }

  function setStatus(msg) {
    var ctrl = $control();
    if (!ctrl) return;
    var s = ctrl.querySelector('.infinite-3nds__status');
    if (s) s.textContent = msg;
  }

  function showSpinner(show) {
    var ctrl = $control();
    if (!ctrl) return;
    var sp = ctrl.querySelector('.infinite-3nds__spinner');
    var btn = ctrl.querySelector('.infinite-3nds__more');
    if (sp) sp.hidden = !show;
    if (btn) btn.disabled = show;
  }

  function teardownIO() {
    if (io) { io.disconnect(); io = null; }
  }

  function loadNext() {
    if (loading) return;
    var ctrl = $control();
    var grid = $grid();
    if (!ctrl || !grid) return;

    var nextUrl = ctrl.getAttribute('data-next-url');
    if (!nextUrl) { teardownIO(); return; }

    loading = true;
    showSpinner(true);
    setStatus('Laddar fler produkter …');

    fetch(nextUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var items = newGrid ? newGrid.querySelectorAll(':scope > li.grid__item') : [];
        var added = 0;

        Array.prototype.forEach.call(items, function (li) {
          // Ta bort scroll-animationsklasser så appendade kort syns direkt
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          li.removeAttribute('data-cascade');
          grid.appendChild(document.importNode(li, true));
          added++;
        });

        // Uppdatera nästa-URL från den hämtade sidans kontroll
        var newCtrl = doc.querySelector('#' + CONTAINER_ID + ' .infinite-3nds');
        var newNext = newCtrl ? newCtrl.getAttribute('data-next-url') : null;

        if (newNext) {
          ctrl.setAttribute('data-next-url', newNext);
        } else {
          // Inga fler sidor: sluta läsa in och ta bort kontrollen så footern nås
          ctrl.removeAttribute('data-next-url');
          teardownIO();
          ctrl.parentNode && ctrl.parentNode.removeChild(ctrl);
        }

        setStatus(added > 0 ? (added + ' fler produkter laddades.') : 'Inga fler produkter.');
      })
      .catch(function () {
        setStatus('Kunde inte ladda fler produkter just nu.');
      })
      .then(function () {
        loading = false;
        showSpinner(false);
      });
  }

  function initInfinite() {
    teardownIO();
    var container = $container();
    var ctrl = $control();
    if (!container || !ctrl) return;

    container.classList.add('infinite-3nds--js');

    var btn = ctrl.querySelector('.infinite-3nds__more');

    if ('IntersectionObserver' in window) {
      if (btn) btn.hidden = true; // auto-load: dölj fallback-knappen
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { loadNext(); break; }
        }
      }, { rootMargin: '600px 0px' });
      io.observe(ctrl);
    } else if (btn) {
      // Fallback utan IntersectionObserver: "Visa fler"-knapp
      btn.hidden = false;
      if (!btn.dataset.bound) {
        btn.addEventListener('click', loadNext);
        btn.dataset.bound = '1';
      }
    }
  }

  function watchContainer() {
    var container = $container();
    if (!container || mo) return;
    // Endast direkta barnbyten (filter/sort ersätter #ProductGridContainer-innehållet).
    // Våra egna appendar sker djupare i #product-grid och triggar därför inte detta.
    mo = new MutationObserver(function () {
      loading = false;
      initInfinite();
    });
    mo.observe(container, { childList: true });
  }

  function boot() {
    if (!$container()) return;
    initInfinite();
    watchContainer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
